// import React, { useState } from "react";
// import Autocomplete from "@mui/material/Autocomplete";
// import TextField from "@mui/material/TextField";
// import Chip from "@mui/material/Chip";

import React from "react";
import { useField, useFormikContext } from "formik";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Chip from "@mui/material/Chip";

const CreatableAutocomplete = ({ name, label, placeholder }) => {
  const [field, meta] = useField(name);
  const { setFieldValue, setFieldTouched } = useFormikContext();
  const [inputValue, setInputValue] = React.useState("");

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && inputValue.trim()) {
      event.preventDefault();
      if (!field.value.includes(inputValue.trim())) {
        setFieldValue(name, [...field.value, inputValue.trim()]);
      }
      setInputValue("");
    }
  };
  return (
    <Autocomplete
      multiple
      freeSolo
      options={[]} // optional: predefined list
      value={field.value || []}
      inputValue={inputValue}
      onInputChange={(e, newInputValue) => setInputValue(newInputValue)}
      onChange={(e, newValue) => {
        setFieldValue(name, newValue);
      }}
      onBlur={() => setFieldTouched(name, true)}
      filterSelectedOptions
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip
            variant="outlined"
            label={option}
            {...getTagProps({ index })}
            key={index}
          />
        ))
      }
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          onKeyDown={handleKeyDown}
          error={meta.touched && Boolean(meta.error)}
          helperText={meta.touched && meta.error}
        />
      )}
    />
  );
};

export default CreatableAutocomplete;
